import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, DestroyRef, inject, type OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DomSanitizer, type SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-icons',
  templateUrl: './icons.component.html',
  styleUrl: './icons.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconsComponent implements OnInit {
  readonly #dr = inject(DestroyRef);
  readonly #http = inject(HttpClient);
  readonly #sanitizer = inject(DomSanitizer);

  protected readonly icons = signal<SafeHtml>('');

  public ngOnInit(): void {
    this.#http
      .get('/assets/icons/icon-set.svg', { responseType: 'text' })
      .pipe(takeUntilDestroyed(this.#dr))
      .subscribe(res => {
        this.icons.set(this.#sanitizer.bypassSecurityTrustHtml(res));
      });
  }
}
